<template>
  <el-dialog
    class="report-download-dialog"
    :title="title"
    :visible.sync="visible"
    :width="width"
    append-to-body
    :close-on-click-modal="false"
    @closed="stopPolling"
  >
    <div class="report-toolbar">
      <el-button
        size="small"
        icon="el-icon-refresh"
        :loading="tableLoading"
        @click="loadList(true)"
        >刷新进度</el-button
      >
      <span class="report-toolbar-hint"
        >下载包就绪后可重复下载；失败时可重试未完成部分。</span
      >
    </div>
    <el-table
      class="report-download-table"
      :data="exportList"
      stripe
      border
      height="500px"
      v-loading="tableLoading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column prop="id" label="批次" width="70" align="center" />
      <el-table-column label="生成时间" width="175"
        ><template slot-scope="scope">{{
          formDateFormat(scope.row.createTime)
        }}</template></el-table-column
      >
      <el-table-column label="处理状态" width="150" align="center"
        ><template slot-scope="scope"
          ><el-tag size="small" :type="statusTagType(scope.row)">{{
            statusText(scope.row)
          }}</el-tag></template
        ></el-table-column
      >
      <el-table-column label="进度与结果" min-width="250">
        <template slot-scope="scope">
          <div v-if="scope.row.workflow">
            <div>
              报告 {{ scope.row.workflow.completedCount }}/{{
                scope.row.workflow.totalCount
              }}，失败 {{ scope.row.workflow.failedCount }} 份
            </div>
            <div v-if="scope.row.workflow.packageCount">
              已整理 {{ scope.row.workflow.packageCount }} 份报告
            </div>
            <div v-if="scope.row.workflow.heartbeatTime">
              最近心跳：{{ formDateFormat(scope.row.workflow.heartbeatTime) }}
            </div>
            <div style="color: #ec0b0b">
              {{ scope.row.workflow.errorMessage }}
            </div>
          </div>
          <!-- 报告结果按文本显示，避免历史输入被当作 HTML 执行。 -->
          <div v-else>{{ plainResult(scope.row.resultMsg) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createBy"
        label="操作人"
        width="90"
        align="center"
      />
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.workflowEnabled" class="report-actions">
            <el-button
              v-if="isReady(scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-download"
              :disabled="!!busyRows[scope.row.id]"
              @click="clickDownloadReport(scope.row)"
              >下载报告包</el-button
            >
            <el-button
              v-if="isReady(scope.row)"
              size="mini"
              icon="el-icon-message"
              plain
              :disabled="!!busyRows[scope.row.id]"
              @click="sendPassword(scope.row)"
              >发送解压密码</el-button
            >
            <el-button
              v-if="canPrepare(scope.row)"
              type="primary"
              size="mini"
              :icon="scope.row.workflow ? 'el-icon-refresh' : 'el-icon-box'"
              plain
              :disabled="!!busyRows[scope.row.id]"
              @click="prepare(scope.row)"
              >{{
                scope.row.workflow ? "重试未完成部分" : "准备下载包"
              }}</el-button
            >
            <span
              v-if="!isReady(scope.row) && !canPrepare(scope.row)"
              class="report-action-empty"
              >—</span
            >
          </div>
          <el-button
            v-else-if="scope.row.state === 2"
            type="primary"
            size="mini"
            icon="el-icon-download"
            class="report-legacy-download"
            :disabled="!!busyRows[scope.row.id]"
            @click="clickDownloadReport(scope.row)"
            >下载比对报告</el-button
          >
          <span v-else class="report-action-empty">—</span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import {
  exportReportTaskList,
  downloadReportAsync,
  prepareReportPackage,
  downloadPreparedReport,
  notifyReportPassword,
} from "@/api/report";
import { dateFormat } from "@/utils/date";
import { downFiles } from "@/utils";
import { exportprocess } from "@/api/student";
export default {
  name: "exportInSchedule",
  props: {
    width: { type: String, default: "1100px" },
    title: { type: String, default: "报告进度" },
    exportStudentButton: { type: Boolean, default: false },
    download: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: false,
      studentId: "",
      exportList: [],
      tableLoading: false,
      busyRows: {},
      pollTimer: null,
      legacyTimers: {},
      viewVersion: 0,
      requestVersion: 0,
    };
  },
  beforeDestroy() {
    this.stopPolling();
  },
  watch: {
    visible(value) {
      if (!value) this.stopPolling();
    },
  },
  methods: {
    formDateFormat(value) {
      return value ? dateFormat("YYYY-mm-dd HH:MM:SS", new Date(value)) : "";
    },
    plainResult(value) {
      return (value || "").replace(/<br\s*\/?\s*>|<\/br>/gi, "；");
    },
    isReady(row) {
      return row.workflow && row.workflow.status === 2;
    },
    canPrepare(row) {
      return row.workflow
        ? [3, 4].includes(row.workflow.status)
        : row.state === 2;
    },
    statusText(row) {
      const job = row.workflow;
      if (!job)
        return (
          {
            0: "待生成",
            1: "正在生成",
            2: row.workflowEnabled ? "待准备下载包" : "生成成功",
            3: "生成失败",
          }[row.state] || "未知状态"
        );
      if (job.status !== 1)
        return (
          { 0: "排队中", 2: "可下载", 3: "处理失败", 4: "执行中断" }[
            job.status
          ] || "未知状态"
        );
      return (
        {
          GENERATE: "正在生成报告",
          CHECKING: "核对已有报告",
          PACKAGE: "整理下载包",
          COMPRESS: "压缩中",
          UPLOAD: "上传下载包",
        }[job.phase] || "处理中"
      );
    },
    statusTagType(row) {
      if (row.workflow)
        return (
          { 0: "info", 1: "", 2: "success", 3: "danger", 4: "warning" }[
            row.workflow.status
          ] || ""
        );
      return { 0: "info", 1: "", 2: "success", 3: "danger" }[row.state] || "";
    },
    stopPolling() {
      clearTimeout(this.pollTimer);
      Object.values(this.legacyTimers).forEach(clearTimeout);
      this.legacyTimers = {};
      this.viewVersion++;
      this.tableLoading = false;
      this.busyRows = {};
      this.pollTimer = null;
      this.requestVersion++;
    },
    async loadList(showLoading = false) {
      clearTimeout(this.pollTimer);
      const version = ++this.requestVersion;
      if (showLoading) this.tableLoading = true;
      try {
        const response = await exportReportTaskList(this.studentId);
        if (version !== this.requestVersion || !this.visible) return;
        if (response.code != 0)
          throw new Error(response.message || "查询报告进度失败");
        this.exportList = response.data || [];
        const active = this.exportList.some((row) =>
          row.workflow
            ? [0, 1].includes(row.workflow.status)
            : [0, 1].includes(row.state)
        );
        if (active) this.pollTimer = setTimeout(() => this.loadList(), 5000);
      } catch (error) {
        if (version === this.requestVersion && this.visible)
          this.$message.error(error.message || "查询失败，请点击刷新进度");
      } finally {
        if (version === this.requestVersion) this.tableLoading = false;
      }
    },
    async prepare(row) {
      this.$set(this.busyRows, row.id, true);
      try {
        const response = await prepareReportPackage(row.id);
        if (response.code != 0) throw new Error(response.message || "提交失败");
        this.$message.success(response.message);
        await this.loadList();
      } catch (error) {
        this.$message.error(error.message || "提交失败");
      } finally {
        this.$set(this.busyRows, row.id, false);
      }
    },
    async sendPassword(row) {
      this.$set(this.busyRows, row.id, true);
      try {
        await notifyReportPassword(row.id);
      } catch (error) {
        // 密码通知静默执行，发送结果或请求异常均不弹窗，也不阻断报告包下载。
      } finally {
        this.$set(this.busyRows, row.id, false);
      }
    },
    async clickDownloadReport(row) {
      let keepBusy = false;
      this.$set(this.busyRows, row.id, true);
      try {
        if (row.workflowEnabled) {
          const response = await downloadPreparedReport(row.id);
          if (response.code != 0 || !response.data || !response.data.url)
            throw new Error(response.message || "下载链接不存在");
          // 使用服务端签名中的文件名，不再追加参数改变 OSS 签名地址。
          downFiles(response.data.url, response.data.fileName, false);
          await this.sendPassword(row);
        } else {
          const response = await downloadReportAsync(row.id);
          if (response.code != 0)
            throw new Error(response.message || "下载请求失败");
          keepBusy = true;
          this.legacyPoll(response.data.taskNo, row.id);
        }
      } catch (error) {
        this.$message.error(error.message || "下载失败");
      } finally {
        if (!keepBusy) this.$set(this.busyRows, row.id, false);
      }
    },
    async legacyPoll(taskNo, id, version = this.viewVersion) {
      // 兼容尚未启用新流程的服务器；采用非阻塞提示，关闭弹窗即停止轮询。
      if (!this.visible || version !== this.viewVersion) return;
      try {
        const response = await exportprocess(taskNo);
        if (!this.visible || version !== this.viewVersion) return;
        if (response.code != 0 || !response.data)
          throw new Error(response.message || "导出状态查询失败");
        if (response.data.state == 0) {
          this.$set(this.busyRows, id, true);
          this.legacyTimers[id] = setTimeout(
            () => this.legacyPoll(taskNo, id, version),
            2000
          );
        } else if (response.data.state == 1 && response.data.url) {
          downFiles(response.data.url, "", false);
          this.$set(this.busyRows, id, false);
        } else
          throw new Error(
            (response.data.msg || [])[0] || "导出未完成，请重新查询"
          );
      } catch (error) {
        if (!this.visible || version !== this.viewVersion) return;
        this.$set(this.busyRows, id, false);
        this.$message.error(error.message || "导出状态查询失败");
      }
    },
    async initData(id) {
      this.stopPolling();
      this.studentId = id;
      this.exportList = [];
      this.busyRows = {};
      this.visible = true;
      await this.loadList(true);
    },
  },
};
</script>

<style scoped>
.report-download-dialog ::v-deep .el-dialog {
  max-width: calc(100vw - 32px);
}

.report-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.report-toolbar-hint {
  color: #909399;
  font-size: 13px;
  line-height: 20px;
}

.report-download-table ::v-deep .cell {
  line-height: 24px;
}

/* 时间保持完整一行，避免秒数被挤到下一行。 */
.report-download-table ::v-deep td:nth-child(2) .cell {
  white-space: nowrap;
}

/* 主次操作统一宽度并垂直对齐，覆盖组件默认的相邻按钮左边距。 */
.report-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.report-actions .el-button,
.report-legacy-download {
  width: 140px;
  margin: 0;
  padding: 8px 10px;
  border-radius: 4px;
}

.report-actions .el-button + .el-button {
  margin-left: 0;
}

.report-action-empty {
  color: #c0c4cc;
}
</style>
